import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

import { RdsDataProductSelectionModule } from '../data-product-selection/index';
import { RdsDataProductSelectionDialogComponent } from './data-product-selection-dialog.component';

const COMPONENTS = [RdsDataProductSelectionDialogComponent];

@NgModule({
  imports: [CommonModule, MatButtonModule, MatDialogModule, RdsDataProductSelectionModule],
  exports: [COMPONENTS],
  declarations: [COMPONENTS],
  entryComponents: [RdsDataProductSelectionDialogComponent]
})
export class RdsDataProductSelectionDialogModule {}

export * from './data-product-dialog.service';
export * from './data-product-selection-dialog.component';
